<div class="show-underlay" [class.active]="showsDropdownVisible" (click)="hideShowsDropdown()">

</div>
<div class="mobile-sidebar" [class.active]="sidebarVisible">
  <ul #menu id="mobile-menu-list">
    <li><a routerLinkActive="active" routerLink="/" [routerLinkActiveOptions]="{exact: true}">
      <span>Home</span></a></li>
    <li><a routerLinkActive="active" routerLink="/live/schedule">
      <span *ngIf="!isLive">Live</span>
      <tyt-live-tag *ngIf="isLive"></tyt-live-tag>
    </a></li>
    <li><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['shows'] }" routerLink="/shows"><span>Shows</span></a></li>
    <li><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['podcasts'] }" routerLink="/podcasts"><span>Podcasts</span></a></li>
    <li><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['stories'] }" routerLink="/stories"><span>Stories</span></a></li>
    <li *ngIf="communityEnabled"><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['community'] }" routerLink="/community"><span>Community</span></a></li>

    <ng-container *ngIf="!user">
      <li><a routerLink="/login"><span>Login</span></a></li>
    </ng-container>
    
    <ng-container *ngIf="user">
      <li><a routerLinkActive="active" routerLink="/settings/profile"><span>Profile</span></a></li>
      <li><a routerLink="/settings/account"><span>Account</span></a></li>
      <li><a (click)="signOut()" href="javascript:;"><span>Logout</span></a></li>
    </ng-container>
  </ul>
  <tyt-shows-sidebar title="Popular Shows"></tyt-shows-sidebar>
</div>

<div class="mobile-sidebar-bg" [class.active]="sidebarVisible || showAccountMenu" (click)="sidebarVisible = false; showAccountMenu = false;"></div>

<div id="mobile-menu-background"
  onclick="document.querySelector('nav#menu').classList.remove('active'); 
           document.querySelector('#mobile-menu-background').classList.remove('active');
           document.documentElement.classList.remove('menu-open');"></div>
<nav id="menu" [class.hidden]="noLayout">
  <div class="site-wide-alerts">
    <ng-container *ngFor="let alert of alerts">
      <div class="site-wide-alert" 
        [class.danger]="alert.type == 'danger'" 
        [class.warning]="alert.type == 'warning'" 
        [style.background-color]="alert.backgroundColor" 
        [style.color]="alert.textColor"
        >
        <a class="message" *ngIf="alert.url && !alert.internal" target="_blank" [href]="alert.url">{{alert.message}} &raquo;</a>
        <a class="message" *ngIf="alert.url && alert.internal" [routerLink]="alert.url">{{alert.message}} &raquo;</a>
        <a class="message" *ngIf="!alert.url">{{alert.message}} &raquo;</a>
        <a class="close-btn" href="javascript:;" (click)="dismissAlert(alert)">
          <div>
            <i class="fas fa-times"></i>
          </div>
        </a>
      </div>
    </ng-container>
  </div>

  <div class="size-container">
    <ul #menu id="menu-list">
      <li><a routerLinkActive="active" routerLink="/" [routerLinkActiveOptions]="{exact: true}">
        <span>Home</span></a></li>
      <li><a routerLinkActive="active" routerLink="/live/schedule">
        <span *ngIf="!isLive">Live</span>
        <tyt-live-tag *ngIf="isLive"></tyt-live-tag>
      </a></li>
      
      <li class="shows-nav">
        <a href="javascript:;" routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['shows'] }" routerLink="/shows" ><span>Shows</span></a>
        <div id="shows-dropdown" [class.visible]="showsDropdownVisible">
          <div class="triangle"></div>
          <div class="header">
            <span>Shows</span>
            <a href="javascript:;" (click)="hideShowsDropdown()"><i class="fas fa-times"></i></a>
          </div>
          <div class="drop-content">
            <tyt-shows-sidebar [title]="'NETWORK SHOWS'"></tyt-shows-sidebar>
          </div>
        </div>
      </li>
      <li><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['podcasts'] }" routerLink="/podcasts"><span>Podcasts</span></a></li>
      <li><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['stories'] }" routerLink="/stories"><span>Stories</span></a></li>
      <li *ngIf="communityEnabled"><a routerLinkActive="active" [ngClass]="{ 'highlight' : highlightMap['community'] }" routerLink="/community"><span>Community</span></a></li>
    </ul>
    <div class="mobile-menu">
        <a href="javascript:;" (click)="sidebarVisible = !sidebarVisible; showAccountMenu = false;"><i class="fas fa-bars"></i></a>
    </div>

    <div class="spacer"></div>

    <a id="logo" routerLink="/home" aria-label="Home">
      <svg class="tyt nav-logo" version="1.1" x="0px" y="0px"
        viewBox="0 0 279.1 198.2" style="enable-background:new 0 0 279.1 198.2;" xml:space="preserve">
        <style type="text/css">
          .nav-logo .st0{fill:#FFFFFF;}
        </style>
        <path d="M265,0h-251C6.3,0,0,6.3,0,14.1v126.2c0,6,3.8,11.3,9.4,13.3L134,197.4c3,1,6.2,1.1,9.2,0.1l126.4-42.6
          c5.7-1.9,9.6-7.3,9.6-13.3V14.1C279.1,6.3,272.8,0,265,0z"/>
        <g>
          <path class="st0" d="M94.6,49.1l-6.5-19.6c-0.4-1.2-1.5-2-2.7-2H24.6c-1.8,0-3.2,1.7-2.8,3.5l4.4,19.6c0.3,1.3,1.5,2.3,2.8,2.3
            h17.3c1.6,0,2.9,1.3,2.9,2.9v84c0,1.3,0.9,2.5,2.3,2.8l21.1,4.7c1.8,0.4,3.5-1,3.5-2.8V55.8c0-1.6,1.3-2.9,2.9-2.9h12.9
            C93.8,52.9,95.2,50.9,94.6,49.1z"/>
          <path class="st0" d="M184.5,49.1l6.5-19.6c0.4-1.2,1.5-2,2.7-2h60.7c1.8,0,3.2,1.7,2.8,3.5l-4.4,19.6c-0.3,1.3-1.5,2.3-2.8,2.3
            h-17.3c-1.6,0-2.9,1.3-2.9,2.9v84c0,1.3-0.9,2.5-2.3,2.8l-21.1,4.7c-1.8,0.4-3.5-1-3.5-2.8V55.8c0-1.6-1.3-2.9-2.9-2.9h-12.9
            C185.2,52.9,183.9,50.9,184.5,49.1z"/>
          <path class="st0" d="M154.2,29.5l-14.7,45.4l-14.7-45.4c-0.4-1.2-1.5-2-2.7-2h-21.7c-2,0-3.4,2-2.7,3.8l26.4,75.3
            c0.1,0.3,0.2,0.6,0.2,0.9l0.3,51.8c0,1.3,0.9,2.5,2.2,2.8l12.2,3c0.5,0.1,0.9,0.1,1.4,0l12.2-3c1.3-0.3,2.2-1.5,2.2-2.8l0.3-51.8
            c0-0.3,0.1-0.6,0.2-0.9l26.4-75.3c0.7-1.9-0.7-3.8-2.7-3.8h-21.7C155.6,27.5,154.5,28.3,154.2,29.5z"/>
        </g>
      </svg>
    </a>

    <div class="spacer"></div>
    <div class="account-menu" [class.visible]="showAccountMenu" *ngIf="user">
      <a href="{{profileUrl}}">
        <i class="fas fa-user-circle" aria-hidden="true"></i>
        Profile
      </a>
      <a href="{{accountUrl}}">
        <i class="fas fa-user-circle" aria-hidden="true"></i>
        Account
      </a>
      <a href="{{communicationPrefUrl}}">
          <i class="fas fa-user-circle" aria-hidden="true"></i>
          Preferences
        </a>
      <a target="_blank" href="{{platformUrl}}" *ngIf="user.staff">
        <i class="fas fa-lock" aria-hidden="true"></i>
        Platform
      </a>
      <a (click)="signOut()" href="javascript:;">
        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        Logout
      </a>
    </div>
    
    <div id="account-mobile" class="only-mobile">
      <!-- <div>
        <ng-container *ngIf="casting">
          <tyt-cast-button></tyt-cast-button>
        </ng-container>
      </div> -->

      <a class="account-c2a join-tyt-plus" href="{{joinUrl}}" *ngIf="!user">
        Join 
        <span class="tyt">TYT</span>
      </a>

      <a *ngIf="!user" class="settings-button icon-button" routerLink="/login">
        <i class="fas fa-cog" aria-hidden="true"></i>
      </a>
      <a *ngIf="user" routerLink="/settings">
          Hi! &nbsp;
          <i class="fas fa-cog" aria-hidden="true"></i>
        </a>
    </div>
    <div id="account" class="only-desktop">
      <div>
        <ng-container *ngIf="casting">
          <tyt-cast-button></tyt-cast-button>
        </ng-container>
      </div>
      <a class="donate-c2a" target="_blank" href="https://secure.actblue.com/donate/tytnetwork" *ngIf="user && user.membership && user.membership.entitled && user.membership.payment_status != 'past_due'">
        Yes!
      </a>
      <a class="store-c2a" target="_blank" href="https://shoptyt.com/">
        Shop
      </a>

      <a class="account-c2a join-tyt-plus" href="{{joinUrl}}" *ngIf="!user">
        Join TYT Plus
      </a>
      <ng-container *ngIf="user">
          <a class="account-c2a" href="{{accountUrl}}" *ngIf="user.staff">Staff</a>
          <ng-container *ngIf="!user.staff">
            <a class="account-c2a" href="{{joinUrl}}" *ngIf="!user.membership">Join TYT!</a>
            <!-- <ng-container *ngIf="user.membership">
              <ng-container *ngIf="!user.membership.cancelled_at">
                <a class="account-c2a" href="{{accountUrl}}" *ngIf="!user.membership.entitled">Renew TYT!</a>
                <a class="account-c2a" href="{{joinUrl}}" *ngIf="user.membership.entitled && user.membership.payment_status == 'past_due'">Update your billing info</a>
              </ng-container>
              <ng-container *ngIf="user.membership.cancelled_at">
                  <a class="account-c2a" href="{{accountUrl}}" *ngIf="!user.membership.status.canceled">Reactivate membership!</a>
                  <a class="account-c2a" href="{{accountUrl}}" *ngIf="user.membership.status.canceled">Renew TYT!</a>
              </ng-container>
            </ng-container> -->
          </ng-container>
      </ng-container>

      <span class="greeting">
        <ng-container *ngIf="!user">
          <span class="c2a-separator">&nbsp; | </span>
          <a routerLink="/login">Sign in</a>
        </ng-container>
        <ng-container *ngIf="user">
          <span class="c2a-separator">&nbsp; | </span>
          <a href="javascript:;" routerLink="/settings">
            {{userGreeting}} 
            <!-- <span *ngIf="isPastDue" style="color: red">YOUR ACCOUNT IS PAST DUE!</span> -->
          </a>

          <a [class.icon-button]="!user" routerLink="/settings">
            <i class="fas fa-cog" aria-hidden="true"></i>
          </a>
        </ng-container>
      </span>
    </div>
  </div>

</nav>